import { action, observable, set } from "mobx";
import Locale from "~/constants/Locale";
import UiMeet3dLevel from "~/constants/UiMeet3d/UiMeet3dLevel";

export default class ProviderDefaults {
  /**
   * @property {string}
   */
  @observable locale = Locale.ENGLISH;

  /**
   * @property {number}
   */
  @observable uiMeet3dLevel = UiMeet3dLevel.NONE;

  /**
   * @property {string}
   */
  @observable defaultTimezone = "";

  constructor(data) {
    if (data !== undefined) {
      this.setData(data);
    }
  }

  @action
  setData(data) {
    set(this, data);
  }
}
